<script setup lang="ts">
import { seed, reset } from '@/cli/seedData';
import BaseButton from '@/components/BaseButton.vue';
import BaseCheckbox from '@/components/BaseCheckbox.vue';
import BaseInput from '@/components/BaseInput.vue';
import { useNotificationStore } from '@/stores/notificationStore';
import { DateTime } from 'luxon';
import { ref } from 'vue';

const notificationStore = useNotificationStore();

const year = ref<number>(DateTime.now().year);
const month = ref<number>(DateTime.now().month);
const onlyFeedstockIn = ref<boolean>(true);

const isCreating = ref<boolean>(false);
const isResetting = ref<boolean>(false);

async function confirmSeed() {
    isCreating.value = true;
    try {
        if (confirm(`Do you want to create movement data for ${month.value}/${year.value}?`)){
            await seed({ year: year.value, month: month.value, onlyFeedstockIn: onlyFeedstockIn.value });
        }
        notificationStore.addSuccess('done');
    } catch (error) {
        notificationStore.addError((error as Error).message);
    }
    isCreating.value = false;
}

async function confirmReset() {
    isResetting.value = true;
    try {
        if (confirm('Do you really want to delete all movement data for this tenant?')){
            await reset();
        }
        notificationStore.addSuccess('done');
    } catch (error) {
        notificationStore.addError((error as Error).message);
    }
    isResetting.value = false;
}
</script>

<template>
<div class="flex gap-2">
    <BaseInput
        v-model="year"
        label="Year"
        :required="true"
        :inset-label="true"
    />
    <BaseInput
        v-model="month"
        label="Month"
        :required="true"
        :inset-label="true"
    />
    <BaseCheckbox
        v-model="onlyFeedstockIn"
        label="only feedstock"
    />
    <BaseButton
        :loading="isCreating"
        :disabled="isCreating || isResetting"
        @click="confirmSeed()"
    >Seed</BaseButton>
    <BaseButton
        :loading="isResetting"
        :disabled="isCreating || isResetting"
        variant="danger"
        @click="confirmReset()"
    >Reset</BaseButton>
</div>
</template>
